<template>
  <div class="grafico1">
    <!-- Prueba de grafico 1 -->
    <div class="panel panel-flat">
      <div class="panel-heading">
        <h5 class="panel-title">Titulo 1</h5>
      </div>
      <GChart type="ColumnChart" :data="chartData" :options="chartOptions" />
    </div>
    <!-- /Prueba de grafico 1 -->
    <!-- Prueba de grafico 2 -->
    <div class="panel panel-flat">
      <div class="panel-heading">
        <h5 class="panel-title">Individual column searching</h5>
      </div>
      <GChart type="ColumnChart" :data="chartData" :options="chartOptions" />
    </div>
    <!-- /Prueba de grafico 2 -->
  </div>
</template>
<script>
import { GChart } from "vue-google-charts";

export default {
  name: "grafico1",
  data() {
    return {
      lang: this.$store.getters.lang,
      // Array will be automatically processed with visualization.arrayToDataTable function
      chartData: [
        ["Year", "Sales", "Expenses", "Profit"],
        ["2014", 1000, 400, 200],
        ["2015", 1170, 460, 250],
        ["2016", 660, 1120, 300],
        ["2017", 1030, 540, 350]
      ],
      chartOptions: {
        chart: {
          title: "Company Performance",
          subtitle: "Sales, Expenses, and Profit: 2014-2017"
        }
      }
    };
  },
  components: {
    GChart
  }
};
</script>

